export default __webpack_public_path__ + "static/media/view_for_entreo.96d5a1cd.svg";